const header = document.querySelector("header");
const frontpageHero = document.querySelector(".hero__media");

if (frontpageHero) {
  function getHeaderHight() {
    let headerHeight = window.getComputedStyle(header).height;

    return `-${headerHeight} 0px 0px 0px`;
  }

  const heroOptions = {
    rootMargin: '0px', // getHeaderHight(),
    threshold: 0.95
  };

  const heroObserver = new IntersectionObserver(function (
    entries,
    heroObserver
  ) {
    entries.forEach((entry) => {
      // console.log(entry.target);
      if (entry.isIntersecting) {
        header.classList.add("inverse");
      } else {
        header.classList.remove("inverse");
      }
    });
  },
  heroOptions);

  heroObserver.observe(frontpageHero);
}
